import { StitchError } from "../../src/spec/errors.js";
import { Screen } from "./screen.js";
/** Represents a visual theme or branding applied to projects and screens. */
export class DesignSystem {
    client;
    projectId;
    assetId;
    data;
    constructor(client, data) {
        this.client = client;
        this.projectId = typeof data === "string" ? data : data.projectId;
        {
            let _v = typeof data === "string" ? data : data.name;
            if (typeof _v === "string" && _v.startsWith("assets/"))
                _v = _v.slice(7);
            this.assetId = _v;
        }
        this.data = typeof data === "object" ? data : undefined;
    }
    /** Convenience alias for assetId */
    get id() {
        return this.assetId;
    }
    /**
     * Updates a design system for a project. Use this tool when the user wants to change the overall visual theme, style, or branding of the application.
     * Tool: update_design_system
     */
    async update(designSystem) {
        try {
            const raw = await this.client.callTool("update_design_system", { name: `assets/${this.assetId}`, projectId: this.projectId, designSystem });
            return new DesignSystem(this.client, { ...raw, projectId: this.projectId });
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Applies a design system to a list of screens. Use this tool when the user wants to update one or more screens to match the style of a design system.
     * Tool: apply_design_system
     */
    async apply(selectedScreenInstances) {
        try {
            const raw = await this.client.callTool("apply_design_system", { assetId: this.assetId, projectId: this.projectId, selectedScreenInstances });
            return ((raw.outputComponents || []).flatMap((a) => a?.design?.screens || []) || []).map((item) => new Screen(this.client, { ...item, projectId: this.projectId }));
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
}
//# sourceMappingURL=designsystem.js.map